import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import auth from '../../services/auth/auth'
import { isCostExplorerEditor } from '../../utils/adminUtils'

// Authentication guard
export const requireAuth = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (!auth.isAuthenticated()) {
    // Save the original URL including query parameters
    const targetUrl = to.fullPath
    next({
      path: '/login',
      query: { redirect: targetUrl }
    })
  } else {
    next()
  }
}

// Already authenticated guard (for login page)
export const redirectIfAuth = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (auth.isAuthenticated()) {
    // Check for redirect query parameter first
    const redirectPath = to.query.redirect as string
    if (redirectPath) {
      next({ path: redirectPath })
    } else {
      // Check sessionStorage for saved redirect (from OAuth flow)
      const savedRedirect = sessionStorage.getItem('authentik_redirect_to')
      if (savedRedirect) {
        sessionStorage.removeItem('authentik_redirect_to')
        next({ path: savedRedirect })
      } else {
        next({ path: '/' })
      }
    }
  } else {
    next()
  }
}

// Cost Explorer editor guard - requires authentication and edit privileges
// (Platform Admins or PLATFORM-DATA-LEAD). Non-editors are bounced back to
// the Cost Explorer dashboard rather than reaching the teams-mapping page.
export const requireCostExplorerEditor = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (!auth.isAuthenticated()) {
    const targetUrl = to.fullPath
    next({ path: '/login', query: { redirect: targetUrl } })
    return
  }

  if (!isCostExplorerEditor(auth.getUser())) {
    next({ path: '/cost-explorer' })
    return
  }

  next()
}

// Cost Explorer viewer guard — any authenticated devtools user can read the
// dashboard; write actions remain gated by isCostExplorerEditor in the UI
// and COST_WRITE_GROUPS on the BFF.
export const requireCostExplorerViewer = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (!auth.isAuthenticated()) {
    const targetUrl = to.fullPath
    next({ path: '/login', query: { redirect: targetUrl } })
    return
  }

  next()
}

// Admin guard - requires authentication and admin privileges
// export const requireAdmin = (
//   to: RouteLocationNormalized,
//   from: RouteLocationNormalized,
//   next: NavigationGuardNext
// ) => {
//   if (!auth.isAuthenticated()) {
//     // Save the original URL including query parameters
//     const targetUrl = to.fullPath
//     next({
//       path: '/login',
//       query: { redirect: targetUrl }
//     })
//     return
//   }

//   const user = auth.getUser()
//   if (!isAdmin(user)) {
//     // Redirect to home page if not admin
//     next({ path: '/' })
//     return
//   }

//   next()
// }
